import React from "react";
import classNames from "../common/classNames";
import CartDrawer from "./CartDrawer";
import Footer from "./Footer";
import Header from "./Header";

const AppShell = ({ children, products = [], className, headerProps, footerProps }) => (
  <div className={classNames("app-shell", className)}>
    <a className="skip-link" href="#main-content">
      Skip to main content
    </a>
    <Header products={products} {...headerProps} />
    <main className="app-shell__main" id="main-content" tabIndex="-1">
      {children}
    </main>
    <Footer {...footerProps} />
    <CartDrawer />
  </div>
);

export default AppShell;
